import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomIcon } from "datastake-daf/dist/components";
import DafTable from "../../../../components/Table/newTable";
import { useEffect, useMemo } from "react";
import { getSourcesColumns } from "./config";
import { useCountry } from "../../../../helpers/map";
import { useFindInformation } from "../../store";
import { getTerritory } from "../../helper";

export default function Sider({
  mod,
  activeMarker = {},
  getName = () => { },
  fetchLevel = () => { },
  setActiveMarker = () => { },
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getCountry } = useCountry();
  const { locations: { form } } = useFindInformation();

  const { data = {} } = activeMarker;

  const columns = useMemo(() => getSourcesColumns({ t }), [t]);
  const goToDetails = () => navigate(`/app/${mod}/find-information/${data.datastakeId}`)

  useEffect(() => {
    console.log(data.administrativeLevel2)
    if (data.administrativeLevel2) {
      fetchLevel(data?.administrativeLevel2);
    }
  }, [activeMarker]);

  const getTerritoryLabel = () => {
    return getTerritory({ form, country: data.country });
  };

  return (
    <div className="map-sider">
      <div className="sider-header">
        <div
          onClick={() => setActiveMarker(null)}
          className="flex justify-content-center flex-column close-icon"
        >
          <div className="flex justify-content-center">
            <CustomIcon name="Close" width={8} height={8} color="#9DA4AE" />
          </div>
        </div>

        <div className="flex flex-column justify-content-center">
          <h1 className="mb-0">{data.name}</h1>
        </div>
        <Button type="primary" onClick={goToDetails}>
          <CustomIcon name="ArrowUpRight" width={20} height={20} color="white" />
        </Button>
      </div>

      <div className="sider-body">
        <div className="sider-body-row bordered">
          <label>{t('Type')}</label>
          <span>{t('Mine Site')}</span>
        </div>

        <div className="sider-body-row bordered">
          <label>{t('Country')}</label>
          <span>{getCountry(data.country)}</span>
        </div>

        <div className="sider-body-row bordered">
          <label>{t(getTerritoryLabel())}</label>
          <span>
            {getName(data.datapoints.find((d) => d.dataId === 'administrativeLevel2')?.data)}
          </span>
        </div>

        <div className="sider-body-row">
          <label>{t('Available Sources')}</label>
          <span>{data?.sources || 0}</span>
        </div>

        <div className='daf-table-wrapper'>
          <DafTable
            columns={columns}
            data={data.sourcesList}
            rowKey="id"
            size="small"
            doEmptyRows
            pagination={{ pageSize: 7 }}
          />
        </div>
      </div>
    </div>
  );
}
